import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {
  showData: any
  constructor(@Optional() private dialogRef: MatDialogRef<ConfirmDialogComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.showData = {
      'headerTitle': this.data.headerTitle ? this.data.headerTitle : 'Title',
      'confirmMsg': this.data.confirmMsg ? this.data.confirmMsg : 'Are You Sure You want to delete this?',
      'cancelButtonText': this.data.cancelButtonText ? this.data.cancelButtonText : 'Cancel',
      'confirmButtonText': this.data.confirmButtonText ? this.data.confirmButtonText : 'Ok',
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }

  confirmSuccess() {
    if (this.data.confirmActionData.currentPage == "report") {
      this.data.confirmActionData.mrnStatueAction(this.dialogRef, this.data.confirmActionData.that);
    } else if (this.data.confirmActionData.currentPage == "header") {
      this.data.confirmActionData.logoutAction(this.dialogRef, this.data.confirmActionData.that);
    } else if (this.data.confirmActionData.currentPage == "login") {
      this.dialogRef.close('yes');
    } else if (this.data.confirmActionData.currentPage == "patientGallery") {
      this.data.confirmActionData.completeMRNStatueAction(this.dialogRef, this.data.confirmActionData.that);
    } else if (this.data.confirmActionData.currentPage == "reportPdf") {
      this.data.confirmActionData.isSave = true;
      this.dialogRef.close(this.data);
    } else if (this.data.confirmActionData.currentPage == "userListing") {
      this.dialogRef.close('yes');
    }
  }

}
